import { Component, Input, OnChanges, OnInit } from "@angular/core"
import { Router } from "@angular/router"
import NavigationNode from "../../../models/navigationNode.model"
import { Observable } from "rxjs"
import { PreviewService } from "../../../services/preview.service"

@Component({
    selector: "app-side-navigation-mobile",
    templateUrl: "./side-navigation-mobile.component.html",
    styleUrls: ["./side-navigation-mobile.component.scss"],
    standalone: false,
})
export class SideNavigationMobileComponent implements OnInit, OnChanges {
    @Input() public navigationNodes: NavigationNode[]
    @Input() public activeNode: NavigationNode
    isInPreviewMode$: Observable<boolean>
    public secondLevelNodes: NavigationNode[]

    constructor(
        private router: Router,
        private previewService: PreviewService
    ) {}

    public ngOnInit(): void {
        this.secondLevelNodes = this.getLevelTwoNodes()
        this.isInPreviewMode$ = this.previewService.previewOnCollection$
    }

    public ngOnChanges(): void {
        this.secondLevelNodes = this.getLevelTwoNodes()
    }

    public selectNode(node: NavigationNode): void {
        let routerLink: string = this.previewService.previewOnCollection
            ? node.getRouterLink() + "preview"
            : node.getRouterLink()
        this.router.navigate([routerLink], { queryParamsHandling: "merge" })
        this.secondLevelNodes = this.getLevelTwoNodes()
    }

    public getParentNode(): NavigationNode {
        if (this.navigationNodes[0].parents.length === 0) {
            return this.navigationNodes[0]
        } else {
            return this.navigationNodes[0].parents[0]
        }
    }

    public getLevelTwoNodes(): NavigationNode[] {
        return this.getParentNode().children.filter((item: NavigationNode): boolean => {
            return item !== this.activeNode
        })
    }
}
